__turbopack_context__.v({
  "card": "ParagraphRelatedCatalogs-module__wv8FuG__card",
  "cardEyebrow": "ParagraphRelatedCatalogs-module__wv8FuG__cardEyebrow",
  "cardLink": "ParagraphRelatedCatalogs-module__wv8FuG__cardLink",
  "cardName": "ParagraphRelatedCatalogs-module__wv8FuG__cardName",
  "cardSubtitle": "ParagraphRelatedCatalogs-module__wv8FuG__cardSubtitle",
  "cta": "ParagraphRelatedCatalogs-module__wv8FuG__cta",
  "eyebrow": "ParagraphRelatedCatalogs-module__wv8FuG__eyebrow",
  "grid": "ParagraphRelatedCatalogs-module__wv8FuG__grid",
  "header": "ParagraphRelatedCatalogs-module__wv8FuG__header",
  "heading": "ParagraphRelatedCatalogs-module__wv8FuG__heading",
  "iconBox": "ParagraphRelatedCatalogs-module__wv8FuG__iconBox",
  "iconBoxEmpty": "ParagraphRelatedCatalogs-module__wv8FuG__iconBoxEmpty",
  "line": "ParagraphRelatedCatalogs-module__wv8FuG__line",
  "root": "ParagraphRelatedCatalogs-module__wv8FuG__root",
});
